<div id="title--container">
  <h4>Add a laboratory</h4>
  <h5>{{ laboratory()?.laboratoryName }}</h5>
</div>
<hr />
<div id="lab--container">
  <div class="body1">
    Please complete the details below to add a new laboratory.
  </div>
  <div id="form--container">
    <form [formGroup]="addLabForm">
      <app-underlined-form-field
        [parentForm]="addLabForm"
        [field]="labNameField"
      ></app-underlined-form-field>
    </form>
    <div id="button--container">
      <app-button
        label="Add Laboratory"
        buttonId="add-btn"
        (buttonClicked)="onSubmit()"
        [isDisabled]="addLabForm.invalid"
        [isProcessing]="isProcessing()"
      >
      </app-button>
    </div>
  </div>
</div>
<app-modal
  id="super-user-success"
  titleText="Success"
  [primaryText]="addLabSuccessMessage()"
  buttonLayout="double-button"
  primaryButtonText="View Lab"
  primaryButtonId="view-lab-button"
  secondaryButtonText="Add Users"
  secondaryButtonId="add-users-button"
  modalStyle="success"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="success"
  titleText="Success"
  [primaryText]="addLabSuccessMessage()"
  primaryButtonText="Close"
  primaryButtonId="close-button"
  modalStyle="success"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="error"
  titleText="Error"
  [primaryText]="error()?.message"
  primaryButtonText="close"
  primaryButtonId="error-button"
  modalStyle="error"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="attention"
  titleText="Attention"
  primaryText="Your changes have not been saved. Press cancel to return to the form and save your changes, or continue to discard."
  buttonLayout="double-button"
  primaryButtonText="Continue"
  primaryButtonId="confirm-navigation"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-button"
  modalStyle="warning"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
